<template>
  <div id="scaleView">
    <div v-if="$route.name === 'scales'">
      <b-col lg="9" style="padding-left: 0px">
        <h1>{{ $t('privatePage.scales_header') }}</h1>
        <scale-table :scales="scales" :allowEdit="true" v-on:beforeEditScale="beforeEditScale"></scale-table>

        <b-button to="scales/scale" @click.stop="beforeAddScale" class="btn-secondary mt-2">
          {{ $t('privatePage.scale_add_header') }}
        </b-button>
      </b-col>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import scaleTable from '../../components/scales/scaletable'

export default {
  components: {
    scaleTable
  },
  computed: {
    ...mapGetters('scalesModule', ['scales'])
  },
  methods: {
    ...mapActions('scalesModule', ['selectCurrentScale', 'getAllScales']),
    ...mapActions('testSuitesModule', { getTestSuites: 'getTestSuites' }),
    selectObjectsInStore: function(scale) {
      this.selectCurrentScale(scale)
        .then(() => {})
        .catch(() => {})
    },
    beforeAddScale: function() {
      this.selectObjectsInStore({})
    },
    beforeEditScale: function(scale) {
      this.$router.push({ path: '/private/scales/scale' })
      this.selectObjectsInStore(scale)
    }
  },
  created() {
    this.getAllScales()
  }
}
</script>
